<script>
import { preventDefault } from 'svelte/legacy';

import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    normalizeEventXPosition,
    normalizeEventYPosition,
} from '@app/lib/eventPosition.js';
import PositionControls from '@app/components/editor/events/inputs/PositionControls.svelte';
import { toast } from '@zerodevx/svelte-toast';
import * as m from '@app/paraglide/messages.js';

let applyAll = $state(false);

const group = eventGroupState[projectState.selected];
const firstIndex = group?.selected?.[0];
const seedEvent = firstIndex !== undefined ? group.events[firstIndex] : null;

let xPos = $state(seedEvent?.xPos ?? "center");
let yPos = $state(seedEvent?.yPos ?? "end");

let currentEventGroup = $derived(eventGroupState[projectState.selected]);
let displayWidth = $derived(currentEventGroup?.displayWidth || 32);
let displayHeight = $derived(currentEventGroup?.displayHeight || 15);

function updateCaptionPosition() {
    const group = eventGroupState[projectState.selected];
    const indices = applyAll
        ? group.events.map((_, index) => index)
        : [...group.selected];

    indices.forEach((eventIndex) => {
        const event = group.events[eventIndex];

        event.xPos = typeof xPos === "number"
            ? normalizeEventXPosition(event, xPos, displayWidth)
            : xPos;
        event.yPos = typeof yPos === "number"
            ? normalizeEventYPosition(event, yPos, displayHeight)
            : yPos;
    });

    toast.push(m.caption_position_updated(), {
        classes: ["toast-success"],
    });

    insertHistoryAction({
        name: "update caption position",
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState),
        }],
    });

    hideModal();
}
</script>

<div class="modal fade {modalState.selected === 'captionPosition' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="captionPositionModalTitle"
    aria-describedby="captionPositionModalDesc"
    tabindex="-1"
    id="captionPositionModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="captionPositionModalTitle">{m.caption_position()}</h4>
                <button type="button" class="btn-close" id="closePositionModal" aria-label={m.close_dialog()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="captionPositionModalDesc" class="visually-hidden">{m.caption_position_description()}</p>
                <form onsubmit={preventDefault(updateCaptionPosition)}>
                    <div class="mb-3">
                        <PositionControls
                            bind:xPos
                            bind:yPos
                            {displayWidth}
                            {displayHeight}
                            radioGroupName="captionPosition"
                            xSelectId="captionPositionXSelect"
                            ySelectId="captionPositionYSelect" />
                    </div>
                    <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="applyPositionToAll" bind:checked={applyAll} aria-describedby="applyPositionAllHelp">
                        <label class="form-check-label" for="applyPositionToAll">{m.apply_to_all()}</label>
                        <div id="applyPositionAllHelp" class="form-text">{m.apply_caption_position_all_help()}</div>
                    </div>
                    <div class="float-end">
                        <button class="btn btn-primary" id="updatePositionBtn" onclick={updateCaptionPosition} type="button">{m.update_position()}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
